export default __webpack_public_path__ + "static/bg5-26fd57ae0b82eab905feebf127eb9cb8.png";